import { CollectionReference, collection, DocumentData } from "firebase/firestore";
import { db } from "firestore";

export const createCollection = <T = DocumentData>(collectionName: string) => {
  return collection(db, collectionName) as CollectionReference<T>;
};
